const vi = {
    Common: {
        ALL: "Tất cả",
        ADD_NEW: "Thêm mới",
        GO_BACK: "Trở về",
        EDIT: "Chỉnh sửa",
        SAVE: "Lưu",
        VIEW_DETAIL: "Xem chi tiết",
        DELETE: "Xóa",
        CANCEL: "Hủy",
        REQUIRED: "Trường bắt buộc phải có dữ liệu",
        REQUIRED_SERVICE_CODE: "Yêu cầu bắt buộc phải có mã dịch vụ",
        PLEASE_COMPLETE_ALL_INFORMATION: "Vui lòng điền đầy đủ thông tin yêu cầu",
        ERROR: "Đã có phát sinh lỗi trong quá trình xử lý, vui lòng thử lại sau. Xin lỗi vì đã gây bất tiện.",
        CANCEL_ACTION_MESSAGE: "Thông tin chỉnh sửa chưa được lưu. Bạn chắc chắn muốn rời khỏi màn hình hiện tại không?",
        EMAIL: "Email",
        SMS: "Sms",
        NOTIFICATION: "Thông báo",
        SEARCH_TEXT: "Tìm kiếm",
        ENTER_SEARCH_TEXT: "Nhập từ khóa để tìm kiếm",
        UNREAD: "Chưa đọc",
        MARK_READ_ALL: "Đánh dấu đọc tất cả",
        NO_DATA: "Không có dữ liệu",
        NO_DATA_NOTIFI: "Không có thông báo",
        LOADING: "Đang tải dữ liệu",
        NO: "Không",
        YES: "Có",
        DENIED_PERMISSION_NOTIFI: "Bạn chưa có cấp quyền xem thông báo trên ứng dụng",
        PLEASE_SEE: "Vui lòng xem",
        HERE: "tại đây",
        BLOCK: "Chặn",
        REMOVE: "Xóa",
        REPLACE: "Thay thế",
        UPLOAD: "Tải lên",
        CONTINUE: "Tiếp tục",
        PAUSE: "Tạm dừng",
        RECOMMENDED_FORMAT: "Định dạng được đề xuất: {0} x {1} pixels (PNG or JPG)",
        UPLOAD_YOUR: "Tải lên ",
        PUBLISH: "Phát hành",
        STOP_PUBLISH: "Ngừng phát hành",
        UNPUBLISHING: "Hủy phát hành",
        UNPUBLISHED: "Chưa được phát hành",
        PUBLISH_READY: "Sẵn sàng phát hành",
        NOT_PUBLISH_READY: "Chưa sẵn sàng phát hành",
        PUBLISHING: "Đang phát hành",
        PUBLISHED: "Đã phát hành",
        UNKNOWN: "Không xác định",
        Public: "Công cộng",
        Private: "Riêng tư",
        STATUS: "Trạng thái",
        CLOSE: "Đóng",
        INVITE: "Mời",
        REJECT: "Từ chối",
        JOIN: "Tham gia",
    },

    SETTING_FIREBASE: {
        BASIC_INFO: "Thông tin cấu hình firebase",

        ADMIN_SDK: "Admin SDK",
        VAPID_KEY: "Vapid Key",
        CLIENT_CONFIG: "Client Config",
        SERVICE_NAME: "Tên dịch vụ",
        SELECT_SERVICE: "Chọn dịch vụ",
        ENTER_ADMIN_SDK: "Nhập Admin SDK",
        ENTER_VAPID_KEY: "Nhập Vapid Key",
        ENTER_CLIENT_CONFIG: "Nhập Client Config",
        UPDATE_SUCCESS: "Cập nhật thông tin cấu hình Firebase thành công",
    },

    MESSAGE_TEMPLATE: {
        TITLE_MENU: "Mẫu thông báo",
        TITLE_LIST_VIEW: "Danh sách mẫu thông báo",
        TITLE_UPDATE_VIEW: "Cập nhật mẫu thông báo",
        TITLE_DETAIL_VIEW: "Chi tiết thông tin mẫu thông báo",
        TITLE_CREATE_VIEW: "Thêm mới mẫu thông báo",
        BASIC_INFO: "Thông tin mẫu thông báo",

        NAME: "Tên mẫu",
        TITLE: "Tiêu đề",
        CC: "CC",
        BCC: "BCC",
        FROM: "Người gửi",
        TO: "Người nhận",
        TYPE: "Loại",
        CONTENT: "Nội dung",
        INPUT_NAME: "Nhập tên mẫu",
        INPUT_TITLE: "Nhập tiêu đề",
        INPUT_CC: "Nhập CC",
        INPUT_BCC: "Nhập BCC",
        INPUT_FROM: "Nhập người gửi",
        INPUT_TO: "Nhập người nhận",
        SELECT_TYPE: "Chọn loại",
        INPUT_CONTENT: "Nhập nội dung",

        KEYWORD_LIST: "Danh sách từ khóa",
        KEYWORD: "Từ khoá",
        VALUE: "Giá trị",
        INPUT_KEYWORD: "Nhập từ khoá",
        INPUT_VALUE: "Nhập giá trị",

        TENANT: "Người thuê",
        SERVICE: "Dịch vụ",
        ORGANIZATION: "Tổ chức",
        SELECT_TENANT: "Chọn người thuê",
        SELECT_SERVICE: "Chọn dịch vụ",
        SELECT_ORGANIZATION: "Chọn tổ chức",

        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa mẫu thông báo này?",
        DELETE_SUCCESS: "Xóa mẫu thông báo thành công",
        CREATE_SUCCESS: "Tạo mới mẫu thông báo thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin mẫu thông báo thành công",
    },

    MESSAGE_TEMPLATE_CASE: {
        TITLE_MENU: "Hộp mẫu thông báo",
        TITLE_LIST_VIEW: "Danh sách hộp mẫu thông báo",
        TITLE_UPDATE_VIEW: "Cập nhật hộp mẫu thông báo",
        TITLE_DETAIL_VIEW: "Chi tiết thông tin hộp mẫu thông báo",
        TITLE_CREATE_VIEW: "Thêm mới hộp mẫu thông báo",
        BASIC_INFO: "Thông tin hộp mẫu thông báo",

        MESSAGE_TEMPLATE: "Mẫu thông báo",
        SELECT_MESSAGE_TEMPLATE: "Chọn mẫu thông báo",
        CASE: "Trường hợp",
        SELECT_CASE: "Chọn trường hợp sử dụng",
        NAME: "Tên mẫu",
        TITLE: "Tiêu đề",
        CC: "CC",
        BCC: "BCC",
        FROM: "Người gửi",
        TO: "Người nhận",
        TYPE: "Loại",
        CONTENT: "Nội dung",
        INPUT_NAME: "Nhập tên mẫu",
        INPUT_TITLE: "Nhập tiêu đề",
        INPUT_CC: "Nhập CC",
        INPUT_BCC: "Nhập BCC",
        INPUT_FROM: "Nhập người gửi",
        INPUT_TO: "Nhập người nhận",
        SELECT_TYPE: "Chọn loại",
        INPUT_CONTENT: "Nhập nội dung",

        KEYWORD_LIST: "Danh sách từ khóa",
        KEYWORD: "Từ khoá",
        VALUE: "Giá trị",
        INPUT_KEYWORD: "Nhập từ khoá",
        INPUT_VALUE: "Nhập giá trị",

        TENANT: "Người thuê",
        SERVICE: "Dịch vụ",
        ORGANIZATION: "Tổ chức",
        SELECT_TENANT: "Chọn người thuê",
        SELECT_SERVICE: "Chọn dịch vụ",
        SELECT_ORGANIZATION: "Chọn tổ chức",
        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa hộp mẫu thông báo này?",
        DELETE_SUCCESS: "Xóa hộp mẫu thông báo thành công",
        CREATE_SUCCESS: "Tạo mới hộp mẫu thông báo thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin của hộp mẫu thông báo thành công",
    },

    MESSAGE: {
        ERROR: "Đã có phát sinh lỗi trong quá trình xử lý, vui lòng thử lại sau. Xin lỗi vì đã gây bất tiện.",
        SUCCESS: "Thành công",
        PLACEHOLDER: "Chọn...",
        CONFIRM_LOGOUT: "Bạn có muốn đăng xuất?",
        CONFIRM_CREATE: "Bạn có chắc muốn tạo?",
        CONFIRM_UPDATE: "Bạn có chắc muốn cập nhật?",
        CONFIRM_DELETE: "Bạn có thực sự muốn xóa?",
        CONFIRM_DELETE_ALL: "Bạn có thực sự muốn xóa tất cả?",
        CONFIRM_BLOCK: "Bạn có thực sự muốn khoá tài khoản?",
        CONFIRM_SUBMIT: "Bạn có thực sự muốn gửi?",
        CONFIRM_CANCEL: "Bạn có thực sự muốn hủy?",
        CONFIRM_CANCEL_ACTIVE: "Bạn có thực sự muốn hủy kích hoạt?",
        CONFIRM_EXPORT_FILE: "Bạn có thực sự muốn tải tệp?",
        CONFIRM_APPROVE: "Bạn có thực sự muốn phê duyệt?",
        CONFIRM_REJECT: "Bạn có thực sự muốn từ chối?",
        CREATE_SUCCESS: "Tạo thành công",
        UPDATE_SUCCESS: "Cập nhật thành công",
        PAYMENT_SUCCESS: "Thanh toán thành công",
        UPDATE_STATUS_SUCCESS: "Cập nhật trạng thái thành công",
        EXPORT_FILE_SUCCESS: "Tải tệp thành công",
        DELETE_SUCCESS: "Xóa thành công",
        DELETE_ALL_SUCCESS: "Xóa tất cả thành công",
        BLOCK_SUCCESS: "Khoá thành công",
        CANCEL_SUCCESS: "Hủy thành công",
        APPROVE_SUCCESS: "Phê duyệt thành công",
        REJECT_SUCCESS: "Từ chối thành công",
        LOGIN_SUCCESS: "Đăng nhập thành công",
        LOGOUT_SUCCESS: "Đăng xuất thành công",
        CREATE_ERROR: "Tạo không thành công",
        BLOCK_ERROR: "Khoá không thành công",
        UPDATE_ERROR: "Cập nhật không thành công",
        EXPORT_FILE_ERROR: "Tải tệp không thành công",
        CANCEL_ERROR: "Hủy không thành công",
        APPROVE_ERROR: "Phê duyệt không thành công",
        REJECT_ERROR: "Từ chối không thành công",
        DELETE_ERROR: "Xóa không thành công",
        DELETE_ALL_ERROR: "Xóa tất cả không thành công",
        LOGIN_ERROR: "Đăng nhật không thành công",
        LOGOUT_ERROR: "Đăng xuất không thành công",
        EPR_TOKEN: "Phiên đăng nhập đã hết hạn!",
        PASSWORD_ERROR: "Tài khoản hoặc mật khẩu không đúng.",
        CREATE_USER_SUCCESS: "Thêm mới nhân viên thành công",
        PLEASE_COMPLETE_ALL_INFORMATION: "Vui lòng điền đầy đủ thông tin yêu cầu",
        INVALID_EMAIL: "Email không hợp lệ",
        INVALID_PHONENUMBER: "Số điện thoại không hợp lệ",
        CONFIRM_CHANGE_STATUS: "Bạn có chắc chắn muốn thay đổi trạng thái?",
        CHANGE_PHONE_NUMBER_SUCCESS: "Thay đổi số điện thoại thành công",
        CHANGE_PASSWORD_SUCCESS: "Thay đổi mật khẩu thành công",
        CHANGE_PROFILE_SUCCESS: "Thay đổi thông tin cá nhân thành công",
        NO_FUNCTION: "Xin lỗi! Hiện chưa có chức năng này!",
        CANCEL_ACTION_MESSAGE: "Thông tin chỉnh sửa chưa được lưu. Bạn chắc chắn muốn rời khỏi màn hình hiện tại không?",
        TOKEN_EXPIRED: "Hết hạn cho phiên đăng nhập! Vui lòng đăng nhập lại",
        USER_PROFILE_NOT_FOUND: "Không tìm thấy thông tin người dùng, vui lòng đăng nhập lại!",
        CONFIRM_EXPORT: "Bạn có muốn xuất file excel?",
        NOT_FORMAT_IMG: "Không đúng định dạng hình ảnh cho phép! (.png |.gif | .jpeg)",
        LIMIT_NUMBER_OF_PHOTO: "Giới hạn thêm tối thiểu là {0} ảnh và tối đa chỉ {1} ảnh",
        LIMIT_SIZE_OF_IMG: "Kích thước file lớn hơn {0}MB",
        NOT_FOUND: "Không tìm thấy dữ liệu!",
        NOT_PERMISSION: "Rất tiếc, bạn không có quyền truy cập",
        NO_ROLE_UPDATE: "Bạn không có quyền cập nhật",
        NO_ROLE_DELETE: "Bạn không có quyền xóa",
        GROUP_ALREADY_EXIST: "Nhóm đã tồn tại",
        PLEASE_ADD_PERMISSION: "Vui lòng thêm nhóm quyền",
        PLEASE_ADD_GROUP_WORK: "Vui lòng thêm nhóm làm việc",
        DONT_HAVE_ORGANIZATION: "Để sử dụng chức năng này vui lòng tạo hoặc ",
        CORRESPONDING_ORGANIZATION: " tổ chức tương ứng.",
        CONFIRM_ACTIVE_STATUS: "Bạn chắc chắn muốn chuyển sang trạng thái kích hoạt?",
        CONFIRM_IN_ACTIVE_STATUS: "Bạn chắc chắn muốn chuyển sang trạng thái hủy kích hoạt?",
        IN_ACTIVE_STATUS_SUCCESS: "Cập nhật trạng thái sang hủy kích hoạt thành công",
        ACTIVE_STATUS_SUCCESS: "Cập nhật trạng thái sang kích hoạt thành công",
        CHANGE_EMAIL_SUCCESS: "Thay đổi email thành công",
        NO_ADDRESS: "Chưa có thông tin, vui lòng thêm địa chỉ",
    },

    POST: {
        TITLE_MENU: "Quản lý tin tức & bài viết",
        TITLE_LIST_VIEW: "Danh sách tin tức & bài viết",
        TITLE_CREATE_VIEW: "Thêm mới tin tức & bài viết",
        TITLE_UPDATE_VIEW: "Cập nhật tin tức & bài viết",
        TITLE_DETAIL_VIEW: "Xem chi tiết tin tức & bài viết",
        BASIC_INFO: "Thông tin về tin tức & bài viết",

        BANNER: "Banner",
        TITLE: "Tiêu đề",
        ENTER_TITLE: "Nhập tiêu đề",
        CATEGORY: "Danh mục",
        SELECT_CATEGORY: "Chọn danh mục",
        TYPE: "Loại",
        SELECT_TYPE: "Chọn loại",
        DESCRIPTION: "Mô tả",
        ENTER_DESCRIPTION: "Nhập mô tả",
        EVENT_TIME: "Thời gian diễn ra",
        SELECT_EVENT_TIME: "Chọn thời gian diễn ra",
        HIGHLIGHTED: "Nổi bật",
        CONTENT: "Nội dung",

        LESSON_VIDEO_URL: "Địa chỉ video {0}",
        IS_HIGHTLIGHTED: "Là tin tức/ sự kiện/ bài viết nổi bật",

        VIDEO_NOTE: "Video đính kèm (Sẽ luôn được hiển thị ở cuối bài viết)",
        PLEASE_ENTER_URL_VIDEO_FROM_YOUTUBE: "Vui lòng nhập đường dẫn của video từ YouTube",
        ADD_NEW_VIDEO_LINK: "Thêm mới video",
        PUBLISH_STATUS: "Trạng thái phát hành",
        PUBLISH: "Phát hành",
        STOP_PUBLISH: "Ngừng phát hành",
        SEND_NOTIFICATION: "Gửi thông báo",
        PUBLISH_POST: "Phát hành tin tức & bài viết",
        UNPUBLISHING: "Hủy phát hành",
        UNPUBLISHED: "Chưa được phát hành",
        PUBLISH_READY: "Sẵn sàng phát hành",
        NOT_PUBLISH_READY: "Chưa sẵn sàng phát hành",
        PUBLISHING: "Đang phát hành",
        PUBLISHED: "Đã phát hành",
        UNKNOWN: "Không xác định",

        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa tin tức & bài viết này?",
        DELETE_SUCCESS: "Đã xóa tin tức & bài viết thành công",
        CREATE_SUCCESS: "Tạo mới tin tức & bài viết thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin tin tức & bài viết thành công",
        PUBLISH_SUCCESS: "Phát hành tin tức & bài viết thành công",
        STOP_PUBLISH_SUCCESS: "Ngừng phát hành tin tức & bài viết thành công",
    },

    CATEGORY: {
        TITLE_INFO: "Thông tin danh mục",
        COURSE: "Khóa học",
        POST: "Bài viết và tin tức",
        QUESTION: "Câu hỏi",
        TYPE: "Loại",
        PARENT_CATEGORY: "Danh mục cha",
        NAME: "Tên danh mục",
        SELECT_TYPE: "Chọn loại",
        SELECT_PARENT_CATEGORY: "Chọn danh mục cha",
        ENTER_NAME: "Nhập tên danh mục",
        ADD: "Thêm danh mục",
        CREATE_SUCCESS: "Tạo mới danh mục thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin danh mục thành công",
        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa danh mục này?",
        DELETE_SUCCESS: "Xóa danh mục thành công",
    },

    TAG: {
        TAG_INFO: "Thông tin nhãn",
        TAG_NAME: "Tên nhãn",
        ENTER_TAG_NAME: "Nhập tên nhãn",
        SHORT_NAME: "Tên viết tắt",
        ENTER_SHORT_NAME: "Nhập tên viết tắt",
        TYPE_TAG: "Loại nhãn",
        SELECT_TYPE_TAG: "Chọn loại nhãn",
        DESCRIPTION: "Mô tả",
        ENTER_DESCRIPTION: "Nhập mô tả",
        SEQUENCE: "Thứ tự",
        EXPERTISED: "Kỹ năng/Chuyên môn",
        POST: "Bài viết",
        COURSE: "Khóa học",
        DUPLICATE_TAG_NAME: "Trùng tên nhãn",
        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa nhãn này?",
        DELETE_SUCCESS: "Xóa nhãn thành công",
        CREATE_SUCCESS: "Tạo nhãn mới thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin nhãn thành công",
    },

    TOPIC: {
        TITLE_MENU: "Quản lý chủ đề",
        TITLE_LIST_VIEW: "Danh sách chủ đề",
        TITLE_CREATE_VIEW: "Thêm mới chủ đề",
        TITLE_UPDATE_VIEW: "Cập nhật thông tin chủ đề",
        TITLE_DETAIL_VIEW: "Chi tiết thông tin chủ đề",

        BASIC_INFO: "Thông tin chung",
        USER_NAME: "Tên người dùng",
        NAME: "Tên",
        NAME_ALLOWED_CHARS: "Tên chủ đề chỉ gồm những kí tự: a-z A-Z 0-9 - _ . ~ %",
        AVATAR: "Avatar",
        DESCRIPTION: "Mô tả",
        INPUT_NAME: "Nhập tên",
        INPUT_DESCRIPTION: "Nhập mô tả",

        LIST_OF_USER: "Danh sách người dùng",
        SUBSCRIBED: "Đã đăng ký",
        UNSUBSCRIBED: "Hủy đăng ký",
        BLOCKED: "Đã chặn",

        STATUS: "Trạng thái",
        SEARCH_TEXT: "Tìm kiếm theo tên chủ đề",

        TYPE: "Loại",
        SELECT_TYPE: "Chọn loại",
        CATEGORY: "Danh mục",
        SELECT_CATEGORY: "Chọn danh mục",
        UPDATE_SUCCESS: "Cập nhật chủ đề thành công",
        CREATE_SUCCESS: "Tạo mới chủ đề thành công",
        CONFIRM_BLOCK: "Xác nhận chặn người dùng này",
        BLOCK_SUCCESS: "Đã chặn người dùng thành công",
        CONFIRM_DELETE: "Xác nhận xóa chủ đề này",
        DELETE_SUCCESS: "Đã xóa chủ đề thành công",

        TOPIC_NAME: "Chủ đề",
        SELECT_TOPIC: "Chọn chủ đề"
    },

    Validation: {
        TOPIC_NAME: "Sai định dạng tên chủ đề",
        EMAIL_ADDRESS: "Sai định dạng email",
        REQUIRED: "Trường dữ liệu là bắt buộc",
        INVALID_FILE: "File không hợp lệ",
        CANCEL_UPLOAD_IMAGE: "Bạn có muốn hủy tải lên hình ảnh này?",
        UPLOAD_IMAGE_FAILED: "Tải ảnh lên không thành công",
    },

    COMMUNITY: {
        BASIC_INFO: "Thông tin cơ bản",
        APPEARANCE: "Giao diện",
        TYPE: "Loại",
        SELECT_TYPE: "Chọn loại",
        NAME: "Tên",
        INPUT_NAME: "Nhập tên",
        IMAGE: "Hình ảnh",
        DESCRIPTION: "Mô tả",
        INPUT_DESCRIPTION: "Nhập mô tả",
        PRIMARY_COLOR: "Màu chính",
        PRIMARY_COLOR_DESC: "Màu này sẽ được áp dụng trên thanh tiêu đề và các nút",
        FONT: "Phong chữ",
        SELECT_FONT: "Chọn phong chữ",
        FONT_DESC: "Phong chữ này sẽ được áp dụng trên toàn bộ trang.",
        BANNER_IMAGE: "Ảnh bìa",
        PUBLISH_STATUS: "Trạng thái phát hành",
        CONFIRM_DELETE: "Xác nhận xóa cộng đồng này",
        CONFIRM_PUBLISH: "Xác nhận xuất bản",
        CONFIRM_UNPUBLISH: "Xác nhận ngưng xuất bản",
        DELETE_SUCCESS: "Đã xóa thành công",
        PUBLISH_SUCCESS: "Đã xuất bản thành công",
        UNBLISH_SUCCESS: "Đã ngưng xuất bản thành công",
    },

    NOTIFICATION: {
        BASIC_INFO: "Thông tin thông báo",
        TITLE: "Tiều đề",
        ENTER_TITLE: "Nhập tiều đề",
        CONTENT: "Nội dung",
        ENTER_CONTENT: "Nhập nội dung",
        NOTIFICATION_TYPE: "Loại thông báo",
        SELECT_NOTIFICATION_TYPE: "Loại thông báo",
        RECEIVER: "Người nhận",
        SELECT_RECEIVER: "Chọn người nhận",
        GROUP_RECEIVER: "Nhóm người nhận",
        SELECT_GROUP_RECEIVER: "Chọn nhóm người nhận",
        READ: "Đã đọc",
        UNREAD: "Chưa đọc",
        STATUS: "Trạng thái",
        SELECT_STATUS: "Chọn trạng thái",
        SEND_DATE: "Ngày gửi",
        SEND_TIME: "Thời gian gửi",
        RECEIVED_DATE: "Ngày nhận",
        RECEIVED_TIME: "Thời gian nhận",
        SELECT_SEND_DATE: "Chọn ngày gửi",
        SELECT_SEND_TIME: "Chọn thời gian gửi",
        SEND_IMMEDIATELY: "Gửi ngay lập tức",
        SENT: "Đã gửi",
        RECEIVED: "Đã nhận",
        FROM: "Từ",
        TO: "Đến",
        ENTER_TIME: "Chọn thời gian",
        GROUP_CC: "Nhóm Cc",
        GROUP_BCC: "Nhóm Bcc",
        SELECT_GROUP: "Chọn nhóm",
        USER_CC: "Người Cc",
        USER_BCC: "Người Bcc",
        SELECT_USER: "Chọn người dùng",
        BY_MY_SELF: "",
        PENDING: "Chờ xử lý",
        SENDING: "Đang gửi",
        SUCCESS: "Gửi thành công",
        FAILURE: "Gửi thất bại",
        SEE_NOTIFICATION: "Xem thông báo",

        CREATE_SUCCESS: "Tạo thông báo thành công",
        UPDATE_SUCCESS: "Cập nhật thông báo thành công",
        DELETE_SUCCESS: "Xóa thông báo thành công",
        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa thông báo này",
        HAVE_NOT_ORGANIZATION_MESSAGE: "Vui lòng tham gia vào tổ chức trước khi tạo thông báo",
        REQUIRED_GROUP_RECEIVER_OR_RECEIVER: "Vui lòng chọn nhóm người nhận hoặc người nhân để gửi thông báo!",
    },

    FAQ: {
        TITLE_MENU: "Quản lý câu hỏi",
        TITLE_LIST_VIEW: "Các câu hỏi thường gặp",
        TITLE_CREATE_VIEW: "Thêm mới câu hỏi",
        TITLE_UPDATE_VIEW: "Cập nhật thông tin câu hỏi",
        TITLE_DETAIL_VIEW: "Chi tiết thông tin câu hỏi",
        QUESTION: "Câu hỏi",
        ANSWER: "Trả lời",
        INPUT_QUESTION: "Nhập câu hỏi",
        INPUT_ANSWER: "Nhập câu trả lời",
        SEARCH_TEXT: "Tìm kiếm theo câu hỏi hoặc câu trả lời",
        INPUT_SEARCH_TEXT: "Nhập câu hỏi hoặc câu trả lời"
    },

    CHANNEL: {
        TITLE_MENU: "Kênh trao đổi",
        TITLE_LIST_VIEW: "Danh sách kênh trao đổi",
        TITLE_CREATE_VIEW: "Tạo mới kênh trao đổi",
        TITLE_UPDATE_VIEW: "Cập nhật thông tin kênh trao đổi",
        TITLE_DETAIL_VIEW: "Xem chi tiết thông tin kênh trao đổi",
        CREATE_CHANNEL: "Tạo kênh",
        IMAGE: "Ảnh",
        FILE: "File",
        VIDEO: "Video",
        CHANNEL_NAME: "Tên kênh trao đổi",
        CHANNEL_DESCRIPTION: "Mô tả",
        ENTER_NAME: "Nhập tên",

        CREATE_SUCCESS: "Tạo mới thành công kênh trao đổi",
        UPDATE_SUCCESS: "Cập nhật thông tin kênh trao đổi thành công",
        DELETE_SUCCESS: "Xóa kênh trao đổi thành công",
        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa kênh trao đổi này",
        CREATE_NEW_POST: "Tạo mới bài viết",
        UPDATE_POST: "Cập nhật thông tin bài viết",
        CREATE_POST: "Tạo bài viết",
        POST_IN_CHANNEL: "Bài viết trong kênh trao đổi",
        SELECT_CHANNEL: "Chọn kênh trao đổi",
        POST_TITLE: "Tiêu đề bài viết",
        ENTER_TITLE: "Nhập tiêu đề",
        POST_DESCRIPTION: "Mô tả bài viết",
        ENTER_DESCRIPTION: "Nhập mô tả",
        NOTE_TITLE: "Hướng dẫn cuộc trò chuyện trong kênh này bằng kênh bạn chọn.",
        MAX_24_CHAR: "Tối đa 24 ký tự...",
        NOTE_IMG: "Hình ảnh sẽ được hiển thị trong thẻ mô tả hiển thị bên phải.",
        IMG_169: "Tỷ lệ đề xuất khuyến nghị 16:9",
        LINK_COURSE: "Liên kết khóa học",
        CHANGE_LINK_COURSE: "Đổi liên kết khóa học",
        ADD_NEW_LINK_COURSE: "Thêm mới liên kết khóa học",
        NOTE_LINK_COURSE: "Chọn một khóa học mà sinh viên có quyền truy cập, tạo ra trải nghiệm học tập năng động, toàn diện hơn.",
        CHOOSE_LINK_COURSE: "Chọn liên kết khóa học",
        UN_LINK_COURSE: "Hủy liên kết khóa học",
        TOTAL_MEMBER: "Tổng thành viên",
        TOTAL_POST: "Tổng bài viết",
        VIDEO_URL: "Video URL",
        ADD_VIDEO: "Thêm video",
        NOTE_VIDEO_URL: "Nền tảng được hỗ trợ: YouTube, Vimeo, Loom",
        NOTE_IMAGE: "Kích thước tối đa là 100MB",
        INVALID_URL: "Sai định dạng URL",

        CREATE_POST_IN_CHANNEL_SUCCESS: "Tạo bài viết thành công",
        DELETE_POST_IN_CHANNEL_SUCCESS: "Xóa bài viết thành công",
        UPDATE_POST_IN_CHANNEL_SUCCESS: "Cập nhật thông tin bài viết thành công",
        CONFIRM_DELETE_POST_IN_CHANNEL_SUCCESS: "Bạn chắc chắn muốn xóa bài viết này?",

        FOLLOW: "Theo dõi",
        UNFOLLOW: "Ngừng theo dõi",
        PIN: "Pin",
        COMMENTS: "Bình luận",
        PAST_ACTIVITY: "Hoạt động gần đây",
        COMMUNITY_ROLE: "Vai trò",
        WRITE_A_POST: "Tạo bài viết...",
        CONFIRM_JOIN_CHANNEL: "Rất tiếc bạn không phải là thành viên của kênh trao đổi này. Bạn có muốn tham gia vào kênh trao đổi này không?",
    },

    MEMBER: {
        MEMBER: "Thành viên",
        MEMBER_NAME: "Tên thành viên",
        INVITE_MEMBER: "Mời thành viên",
        LIST_MEMBER: "Danh sách thành viên",
        SEARCH_TEXT: "Tìm tên thành viên",
        INPUT_SEARCH_TEXT: "Nhập tên thành viên",
        COMMUNITY_NAME: "Tên cộng đồng",
        SELECT_COMMUNITY: "Chọn cộng đồng",
        ROLE_NAME: "Tên vai trò",
        SELECT_ROLE: "Chọn vai trò",
        INPUT_EMAIL: "Nhập email",
        PLEASE_SELECT_CHANNEL: "Vui lòng chọn kênh trao đổi",
        PLEASE_SELECT_COMMUNITY: "Vui lòng chọn cộng đồng",
        INVITE_TO_CHANNEL: "Mời thành viên vào kênh trao đổi",
        INVITE_TO_COMMUNITY: "Mời thành viên vào cộng đồng",
        INVITE_MEMBER_SUCCESS: "Đã gửi lời mời thành công",
    }

};

export default vi;
